import React, { useState } from 'react';
import { Star } from '@phosphor-icons/react';

/**
 * StarRating — interactive or read-only 1–5 star picker.
 * props: value (number), onChange (fn), size (number), readonly (bool), showValue (bool)
 */
const StarRating = ({ value = 0, onChange, size = 24, readonly = false, showValue = false, testIdPrefix = 'star' }) => {
  const [hover, setHover] = useState(0);
  const display = hover || value;
  return (
    <div className="inline-flex items-center gap-1" data-testid={`${testIdPrefix}-rating`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= display;
        return (
          <button
            type="button"
            key={n}
            disabled={readonly}
            onMouseEnter={() => !readonly && setHover(n)}
            onMouseLeave={() => !readonly && setHover(0)}
            onClick={() => !readonly && onChange && onChange(n)}
            className={`${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'} transition-transform`}
            aria-label={`${n} star${n > 1 ? 's' : ''}`}
            data-testid={`${testIdPrefix}-${n}`}
          >
            <Star
              size={size}
              weight={filled ? 'fill' : 'regular'}
              className={filled ? 'text-amber-500' : 'text-gray-300'}
            />
          </button>
        );
      })}
      {showValue && value > 0 && (
        <span className="text-sm font-bold text-text-primary ml-1">{value.toFixed(1)}</span>
      )}
    </div>
  );
};

export default StarRating;
